module.exports = __webpack_public_path__ + "media/images/restaurant-580c290eeb60703205d737e840e44676.jpg";